import type { CSSProperties } from 'react';
import ProgrammaticWebhookIconSvg from '../../assets/icons/programmatic_native_webhook.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const ProgrammaticWebhookIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <ProgrammaticWebhookIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default ProgrammaticWebhookIcon;
